import { css } from '@/styled-system/css';

export const modalContentWrapperStyles = css.raw({
  position: 'relative',
  flex: 1,
  display: 'flex',
  flexDirection: 'column',
  overflow: 'hidden',
});

export const modalBodyStyles = css.raw({
  flex: 1,
  display: 'flex',
  flexDirection: 'column',
  minHeight: 0,
  paddingInline: 0,
  paddingBlock: 0,
});

// In flow (not an overlay) so thread controls like "Load more messages" stay clickable; the row
// only exists while the chat and drawer point at different leads.
export const switchConversationChipRowStyles = css.raw({
  display: 'flex',
  justifyContent: 'center',
  paddingTop: 'tighter',
  flexShrink: 0,
  maxWidth: '100%',
  paddingInline: 'default',
});

export const switchConversationChipStyles = css.raw({
  height: '800',
  borderRadius: 'pill',
  backgroundColor: 'bg.neutral',
  borderWidth: '1px',
  borderStyle: 'solid',
  borderColor: 'border.muted',
  boxShadow: 'sm',
  paddingInline: 'tight',
  transition: 'transform 0.15s ease, box-shadow 0.15s ease',
  _hover: { transform: 'translateY(-1px)', boxShadow: 'lg' },
});

export const resizeTopEdgeStyles = css.raw({
  position: 'absolute',
  top: 0,
  left: 0,
  right: 0,
  height: '150',
  cursor: 'ns-resize',
  zIndex: 1,
});

export const resizeLeftEdgeStyles = css.raw({
  position: 'absolute',
  top: 0,
  left: 0,
  bottom: 0,
  width: '150',
  cursor: 'ew-resize',
  zIndex: 1,
});

export const resizeGripStyles = css.raw({
  position: 'absolute',
  top: '-250',
  left: '-250',
  cursor: 'nwse-resize',
  zIndex: 2,
  color: 'text.subtle',
  backgroundColor: 'bg.neutral',
  borderWidth: '1px',
  borderStyle: 'solid',
  borderColor: 'border.muted',
  boxShadow: 'lg',
  // Revealed on window hover / keyboard focus so the header stays clean at rest.
  opacity: 0,
  transition: 'opacity 0.15s ease',
  _groupHover: { opacity: 1 },
  _hover: { opacity: 1, backgroundColor: 'bg.neutral' },
  _focusVisible: { opacity: 1 },
});

export const minimizedMessagingPillStyles = css.raw({
  position: 'fixed',
  bottom: '400',
  height: '1200',
  display: 'flex',
  alignItems: 'center',
  borderRadius: 'pill',
  backgroundColor: 'bg.neutral',
  borderWidth: '1px',
  borderStyle: 'solid',
  borderColor: 'border.muted',
  boxShadow: 'lg',
  paddingInline: 'tight',
  transition: 'transform 0.15s ease, box-shadow 0.15s ease',
  _hover: { transform: 'translateY(-2px)' },
});
